import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  private readonly PRESCRIPTIONS_KEY = 'PRESCRIPTIONS';
  private readonly FALLBACK_PRESCRIPTIONS_KEY = 'FALLBACK_TO_PRESCRIPTIONS';

  removeMultiple(keys: string[]): void {
    keys.forEach(key => sessionStorage.removeItem(key));
  }

  getRedirectToPremiumAfterLogin(): boolean {
    return sessionStorage.getItem("redirectToPremiumAfterLogin") === "true";
  }

  setRedirectToPremiumAfterLogin(): void {
    sessionStorage.setItem("redirectToPremiumAfterLogin", "true");
  }

  removeRedirectToPremiumAfterLogin(): void {
    sessionStorage.removeItem("redirectToPremiumAfterLogin");
  }

  getPremiumLink(): string {
    return sessionStorage.getItem("PREMIUM_LINK");
  }

  setPremiumLink(link: string): void {
    sessionStorage.setItem("PREMIUM_LINK", link);
  }

  removePremiumLink(): void {
    sessionStorage.removeItem("PREMIUM_LINK");
  }

  getPaidFlow(): number {
    return JSON.parse(sessionStorage.getItem("PAID_SERVICE_PAID_FLOW"));
  }

  getManuallyReload(): string {
    return sessionStorage.getItem("reloaded");
  }

  setManuallyReload(): void {
    sessionStorage.setItem("reloaded", "true");
  }

  removeManuallyReload() {
    sessionStorage.removeItem("reloaded");
  }

  getIsUserReplyingToMessage() {
    return sessionStorage.getItem("replyToMessage");
  }

  setIsUserReplyingToMessage() {
    sessionStorage.setItem("replyToMessage", "true");
  }

  removeIsUserReplyingOnToMessage() {
    sessionStorage.removeItem("replyToMessage");
  }

  getSessionContext() {
    return JSON.parse(sessionStorage.getItem("sessionContext"));
  }

  getUserRegister(): number {
    return JSON.parse(sessionStorage.getItem("sessionContext")).register?.id;
  }

  hasUserCancelledBiometrics(): boolean {
    return sessionStorage.getItem("biometricAuthenticationCancelled") === 'true';
  }

  setBiometricAuthenticationCancelled(): void {
    sessionStorage.setItem("biometricAuthenticationCancelled", 'true');
  }

  clearBiometricCancellationFlag(): void {
    sessionStorage.removeItem("biometricAuthenticationCancelled");
  }

  setRedirectedToNtPage() {
    sessionStorage.setItem("toNtPage", "true")
  }

  getRedirectedToNtPage() {
    return sessionStorage.getItem("toNtPage");
  }

  removeRedirectedToNtPage() {
    sessionStorage.removeItem("toNtPage");
  }

  storePrescriptionsInSession(prescriptions: any[]): void {
    sessionStorage.setItem(this.PRESCRIPTIONS_KEY, JSON.stringify(prescriptions));
  }

  getPrescriptionsInSession() {
    return sessionStorage.getItem("PRESCRIPTIONS");
  }

  removeStoredPrescriptionsFromSession() {
    sessionStorage.removeItem(this.PRESCRIPTIONS_KEY);
  }

  setFallbackToPrescriptions(enabled: boolean): void {
    if (enabled) {
      sessionStorage.setItem(this.FALLBACK_PRESCRIPTIONS_KEY, 'true');
    } else {
      sessionStorage.removeItem(this.FALLBACK_PRESCRIPTIONS_KEY);
    }
  }

  isFallbackToPrescriptionsEnabled(): boolean {
    return sessionStorage.getItem(this.FALLBACK_PRESCRIPTIONS_KEY) === 'true';
  }

  removeFallbackToPrescriptions(): void {
    sessionStorage.removeItem(this.FALLBACK_PRESCRIPTIONS_KEY);
  }

  setPremiumGraceSession() {
    sessionStorage.setItem("PREMIUM_GRACE_SESSION", "true");
  }

  isPremiumGraceSession(): boolean {
    return sessionStorage.getItem("PREMIUM_GRACE_SESSION") === 'true';
  }

  removePremiumGraceSession(): void {
    sessionStorage.removeItem("PREMIUM_GRACE_SESSION");

  }
}
